



























































































import { keyBy } from 'lodash-es'
import { Icon } from '@alpha/ink'
import store from '@/store'
import api from '../api'
import loadingGif from '@/assets/img/loading.gif'
import { ProjectAudience } from '../types/frontend'
import * as graph from '@shared/types/graphql'
import { format } from '@/utilities/audience-helpers.js'
import { format as dateFormat } from 'date-fns'
import fromUnixTime from 'date-fns/fromUnixTime'
import { Component, Vue } from 'vue-property-decorator'

import { enableOrganizationWorkspaces } from '@/config'

@Component({
  components: { Icon }
})
export default class AudienceManager extends Vue {
  currentIndex = -1
  showInfo = false
  loading = false
  loadingGif = loadingGif
  audienceCounts: graph.AccountAudienceTestCount[] = []
  organizationsById: Record<string, { id: string, name: string }> = {}
  enableOrganizationWorkspaces = enableOrganizationWorkspaces

  async mounted () {
    this.loading = true

    const accountId = store.state.workspace.accountId

    if (accountId) {
      const organizations = await api.getOrganizations(accountId)
      this.organizationsById = keyBy(organizations, o => o.id)
    }

    if (!accountId || !store.state.workspace.accountAudiences.length) {
      this.loading = false
    } else {
      const res = await api.getAudiencesTestCount(accountId, store.state.workspace.accountAudiences.map(a => (a._id)))
      if (res.audienceTestCounts.length) {
        this.audienceCounts = res.audienceTestCounts
        this.loading = false
      }
    }
  }

  get audiences () {
    return store.state.workspace.accountAudiences.filter(aud => {
      return aud.payload.account_id !== 'alpha_featured' && aud._id && !aud.payload.archived
    }).map(newAud => this.formatAudience(newAud))
  }

  get workspaceName () {
    return store.state.workspace.workspace.name
  }

  audienceTestCount (audience: ProjectAudience) {
    const aud = this.audienceCounts.find((a:graph.AccountAudienceTestCount) => a.id === audience.id)
    if (!aud) return 0
    return aud.count
  }

  lastUsed (audience: ProjectAudience):String {
    const rawAudience = store.state.workspace.accountAudiences.find(aud => aud._id === audience.id)
    if (rawAudience) {
      return rawAudience.payload.lastTurnedOn ? this.formatDate(rawAudience.payload.lastTurnedOn) : 'N/A'
    } else {
      return 'N/A'
    }
  }

  formatDate (timeStamp: number) {
    const time = fromUnixTime(timeStamp)
    return dateFormat(time, 'MMM dd, yyyy')
  }

  displayInfo (index:number) {
    if (this.currentIndex === index) {
      this.currentIndex = -1
      this.showInfo = false
    } else {
      this.currentIndex = index
      this.showInfo = true
    }
  }

  formatAudience (audience: Pick<graph.Audience, '_id' | 'payload'>) : ProjectAudience {
    const organization = this.organizationsById[audience.payload.organization_id]

    return {
      title: audience.payload.name,
      id: audience._id,
      isLegacy: false,
      additionalInfo: audience.payload.segment.custom,
      demographics: format.forListingCriteria(audience.payload.segment.lucid),
      organizationName: organization && organization.name
    }
  }

  isVisible (audience: ProjectAudience):boolean {
    const rawAudience = store.state.workspace.accountAudiences.find(aud => aud._id === audience.id)
    if (!rawAudience) return false
    // By default all audiences are visible if we haven't updated this flag yet
    if (!Object.keys(rawAudience.payload.segment).includes('visible') || rawAudience.payload.segment.visible) {
      return true
    } else {
      return false
    }
  }

  async toggleVisibility (audience: ProjectAudience) {
    const accountId = store.state.workspace.accountId || ''
    const audienceId = audience.id || ''

    // Toggle the value by sending update api call
    const res = await api.updateAudienceDepths(accountId, audienceId, {
      name: audience.title,
      payload: {
        segment: {
          visible: !this.isVisible(audience)
        }
      }
    })
    if (!res) return
    const accountAuds = store.state.workspace.accountAudiences.map(aud => {
      if (aud._id === audienceId) {
        if (res.updateAudience) {
          aud.payload = { ...aud.payload, ...res.updateAudience.payload }
        }
      }
      return aud
    })
    store.dispatch.workspace.updateAccountAudiences(accountAuds)
  }
}
